<template>
  <v-card>
    <v-container fluid grid-list-lg>
      <v-layout wrap>
        <v-flex lg12 md12 xs12>
          <v-card elevation="0" min-height="500">
            <v-card-title class="pt-0 mt-0">
              <div class="row" style="width: 100%;">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  class="mr-2 mt-3 fixed-width"
                  hide-details
                  @input="onFilterChanged"
                  :label="$t('GeneralTranslations.Search')"
                  single-line
                ></v-text-field>

                <v-autocomplete
                  v-if="isOrgAdmin"
                  class="fixed-width mr-2 mt-3"
                  hide-details
                  label="Facilities"
                  @change="onFilterChanged"
                  v-model="selectedFacilitiesIds"
                  :search-input.sync="facilitySearch"
                  :items="facilitiesForOrg"
                  :loading="isFacilitiesLoading"
                  :disabled="isFacilitiesLoading"
                  item-text="name"
                  item-value="id"
                  multiple
                ></v-autocomplete>

                <v-spacer></v-spacer>

                <v-btn
                  v-if="user.accessLevel === 'Org Admin'"
                  class="primary mr-2 mt-3"
                  @click="openManageRolesDialog"
                >
                  
                  {{$t('Settings.StaffUsersList.ManageRoles')}}
                </v-btn>

                <v-btn
                  v-if="user.accessLevel === 'Org Admin'"
                  class="primary mr-2 mt-3"
                  @click="openUserAddRoleDialog"
                >
                  
                  {{$t('Settings.StaffUsersList.AddRole')}}

                </v-btn>

                <v-dialog v-model="dialog" max-width="600px" persistent>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="primary mr-2 mt-3" v-if="canAddUser" v-bind="attrs" v-on="on"
                      >{{$t('Settings.StaffUsersList.AddUser')}}</v-btn
                    >
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{$t('Settings.StaffUsersList.CreateUser')}}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container class="p-0">
                        <validation-observer ref="observer" v-slot="{ invalid }">
                          <v-form
                            ref="createUserForm"
                            lazy-validation
                            id="create-user-form"
                            @submit.prevent="submit"
                          >
                            <v-col cols="12">
                              <validation-provider
                                v-slot="{ errors }"
                                name="Name"
                                rules="required"
                              >
                                <v-text-field
                                  v-model="form.name"
                                  :label="$t('Settings.StaffUsersList.Name')+'*'"
                                  :error-messages="errors"
                                ></v-text-field>
                              </validation-provider>
                            </v-col>
                            <v-col cols="12">
                              <validation-provider
                                v-slot="{ errors }"
                                name="Email"
                                rules="required|email"
                              >
                                <v-text-field
                                  v-model="form.email"
                                  :label="$t('Settings.StaffUsersList.EmailAddress')+'*'"
                                  :error-messages="errors"
                                ></v-text-field>
                              </validation-provider>
                            </v-col>
                            <v-col cols="12">
                              <validation-provider
                                v-slot="{ errors }"
                                name="FacilityAccess"
                                rules="required"
                              >
                                <v-select
                                  v-model="form.facilities"
                                  :items="facilitiesForOrg"
                                  :loading="isFacilitiesLoading"
                                  :disabled="isFacilitiesLoading"
                                  :error-messages="errors"
                                  item-text="name"
                                  :label="$t('Settings.StaffUsersList.FacilityAccess')+'*'"
                                  multiple
                                  required
                                  return-object
                                ></v-select>
                              </validation-provider>
                            </v-col>
                            <v-col cols="12">
                              <validation-provider
                                v-slot="{ errors }"
                                name="AccessLevel"
                                rules="required"
                              >
                                <v-select
                                  v-model="form.accessLevel"
                                  :items="staffAccessLevelsList"
                                  item-text="text" 
                                  item-value="value"
                                  :error-messages="errors"
                                  :label="$t('Settings.StaffUsersList.AccessLevel')+'*'"
                                  required
                                ></v-select>
                              </validation-provider>
                            </v-col>
                            <v-col cols="12">
                              <validation-provider
                                v-slot="{ errors }"
                                name="Role"
                                rules=""
                              >
                                <v-select
                                  class="autofocus"
                                  v-model="form.roles"
                                  :items="usersRoles"
                                  item-text="name"
                                  :label="$t('Settings.StaffUsersList.Role')"
                                  :error-messages="errors"
                                  required
                                  multiple
                                ></v-select>
                              </validation-provider>
                            </v-col>

                            <v-col
                              cols="12"
                              v-if="!isStaffUserInviteEmailTemplateExists"
                            >
                              <v-alert dense outlined color="error">
                                <v-row align="center">
                                  <v-col cols="8" class="text-subtitle-2">
                                    {{$t('Settings.StaffUsersList.EmailTemplateWithType')}}
                                    {{$t('Settings.StaffUsersList.MissingStaffUserInviteText')}}
                                  </v-col>
                                  <v-col>
                                    <router-link
                                      @click.native="dialog = false"
                                      class="text-decoration-none"
                                      to="/settings?tab=emailTemplates"
                                      ><v-btn color="primary" block>
                                        {{$t('GeneralTranslations.Create')}}</v-btn
                                      ></router-link
                                    >
                                  </v-col>
                                </v-row>
                              </v-alert>
                            </v-col>

                            <v-col cols="12">
                              <small>{{$t('GeneralTranslations.StarIndicatesRequiredField')}}</small>
                            </v-col>

                            <v-col cols="12">
                              <div class="d-flex">
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="error"
                                  text
                                  class="mr-4"
                                  @click="cancel"
                                  >{{$t('GeneralTranslations.Cancel')}}</v-btn
                                >
                                <v-btn
                                  color="primary"
                                  :disabled="
                                    invalid ||
                                      submited ||
                                      !isStaffUserInviteEmailTemplateExists
                                  "
                                  :loading="submited"
                                  type="submit"
                                  >
                                  {{$t('Settings.StaffUsersList.CreateUser')}}
                                  </v-btn>
                              </div>
                            </v-col>
                          </v-form>
                        </validation-observer>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-dialog>

                <v-btn v-if="canSendUserInvites" class="primary mt-3 mr-2" @click="openUserInvitesDialog">
                  Send User Invites
                </v-btn>

<!--                <PdfDownload
                  v-if="!loading"
                  :page="pdfPages.StaffList"
                  :data="facilityUsers"
                  class="mt-3"
                />-->
              </div>
            </v-card-title>

            <v-data-table
              :headers="headers"
              :items="facilityUsers"
              :search="search"
              @click:row="handleClickUser"
            >
              <template v-slot:item.profilePicUrl="{ item }">
                <v-avatar class="mt-3 mb-3" size="50px">
                  <img :src="item.profilePicUrl" alt />
                </v-avatar>
              </template>
              
              <template v-slot:item.originDisplay="{ item }">
                <div v-if="item.isPcsUser" class="d-flex align-center justify-center">
                  <img 
                    src="/img/pcs/email-templates/pcs-brand-mark-124x124.png" 
                    alt="PCS" 
                    width="30" 
                    height="30"
                    class="mr-2"
                  />
                </div>
                <!-- Show nothing for ResHub users -->
              </template>
              
              <template v-slot:item.verificationStatusDisplay="{ item }">
                <v-chip 
                  :color="getVerificationStatusColor(item.verificationStatusDisplay)"
                  small
                  class="ma-1"
                >
                  <v-icon left small>{{ getVerificationStatusIcon(item.verificationStatusDisplay) }}</v-icon>
                  {{ item.verificationStatusDisplay }}
                </v-chip>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <FacilityUsersRolesDialog v-if="user.accessLevel === accessLevelsEnum.OrgAdmin" ref="facilityUsersRolesDialog"/>

    <FacilityUserAddRoleDialog v-if="user.accessLevel === accessLevelsEnum.OrgAdmin" ref="facilityUserAddRoleDialog"/>

    <InviteUsersDialog v-if="canSendUserInvites" ref="inviteUsersDialogRef"/>

    <v-divider></v-divider>
  </v-card>
</template>

<script>
  import { mapState, mapGetters } from "vuex";
  import * as firebase from "firebase/app";
  import "firebase/firestore";
  import { StaffAccessLevels, SupeAdminAccessLevel } from "@/enums/StaffAccessLevels";
  import { ValidationObserver, ValidationProvider } from "vee-validate";
  import { DEFAULT_AVATAR_BLACK } from "@/consts/default-avatar";
  import { DefaultEmailTemplateType } from "@/enums/DefaultEmailTemplateType";
  import { getRegionName } from "@/utils/functionsRegion";
  import FacilityUsersRolesDialog
    from "@/views/settings/facility/facility-users-roles-dialog/FacilityUsersRolesDialog.vue";
  import FacilityUserAddRoleDialog
    from "@/views/settings/facility/facility-users-add-role-dialog/FacilityUserAddRoleDialog.vue";

  import InviteUsersDialog from "@/views/settings/facility/users-invitation/InviteUsersDialog.vue";
  import { hasAccess } from "@/utils/accessControl/accessControl";
  import { AccessMatrixKeys } from "@/utils/accessControl/accessMatrixKeysEnum";
  import { getAccessLevelDisplayName } from "@/utils/accessControl/getAccessLevelDisplayName";
  import { getStaffAccessLevels } from "@/utils/accessControl/getAccessLevelDisplayName";
  import { UserTypeEnum } from "@/enums/UserTypeEnum";
  import { AuditLogsTier1 as Tier1, AuditLogsTier2 as Tier2, AuditLogsTier3 as Tier3 } from '@/enums/AuditLogs';
  import { isAustraliaResHub } from '@/utils/projectConfig';
  // import PdfDownload from '@/components/pdf/PdfDownload.vue';
  import { PdfPages } from '@/enums/PdfPages';

  export default {
    components: {
      ValidationObserver,
      ValidationProvider,
      FacilityUsersRolesDialog,
      FacilityUserAddRoleDialog,
      InviteUsersDialog,
      //PdfDownload
    },
    name: "StaffUsersList",
    computed: {
      ...mapGetters({
        user: "user"
      }),
      ...mapState({
        facility: state => state.facilityModule.selectedFacility,
        emailTemplates: state => state.facilityModule.facilityEmailTemplates,
        currentUser: state => state.authModule.user,
        staffUsersListFilters: state => state.userModule.userManagementStaffUsersListFilters
      }),
      isHomeAdmin() {
        return this.currentUser.accessLevel === this.accessLevelsEnum.HomeAdmin;
      },
      facilitiesForOrg() {
        const allFacilities = this.$store.state.userModule.facilitiesForOrg;
        // Filter facilities for Home Admins - only show facilities they have access to
        if (this.isHomeAdmin && this.currentUser.facilitiesIds) {
          return allFacilities.filter(facility => 
            this.currentUser.facilitiesIds.includes(facility.id)
          );
        }
        return allFacilities;
      },
      facilityUsers() {
        return this.$store.state.facilityModule.selectedFacilityUsers
          .map(x => {
            const user = { ...x };
            user.accessLevelDisplay = getAccessLevelDisplayName(x.accessLevel);
            // Use the computed properties from the store
            user.isPcsUser = x.refOrigin === 'rci';
            user.passwordVerified = x.isAccountVerified;
            user.originDisplay = x.origin;
            user.verificationStatusDisplay = x.verificationStatus;
            return user;
          })
          .filter(user => {
            // Only apply facility filter for Org Admins
            const matchesFacility = !this.isOrgAdmin || !this.selectedFacilitiesIds.length ||
              (user.facilitiesIds?.some(id => this.selectedFacilitiesIds.includes(id)));

            const isActive = !user.fileClosed;

            const search = this.search?.toLowerCase() || '';
            const matchesSearch =
              !search ||
              user.name?.toLowerCase().includes(search) ||
              user.email?.toLowerCase().includes(search) ||
              user.accessLevelDisplay?.toLowerCase().includes(search);

            return matchesFacility && isActive && matchesSearch;
          });
      },
      staffAccessLevelsList() {
        const hasMaintenanceFeature = this.$store.state.authModule.currentFacilityData?.featureMaintenance || false;
        const allAccessLevels = getStaffAccessLevels(false, hasMaintenanceFeature);
        // Filter access levels for Home Admins - exclude only Org Admin
        if (this.isHomeAdmin) {
          return allAccessLevels.filter(level => 
            level.value !== this.accessLevelsEnum.OrgAdmin
          );
        }
        return allAccessLevels;
      },
      isStaffUserInviteEmailTemplateExists() {
        return (
          this.emailTemplates.filter(
            emailTemplate =>
              emailTemplate.type === DefaultEmailTemplateType.StaffUserInvite
          ).length > 0
        );
      },
      usersRoles() {
        return this.$store.state.userModule.usersRoles;
      },
      isOrgAdmin() {
        return this.currentUser.accessLevel === this.accessLevelsEnum.OrgAdmin || 
               this.currentUser.accessLevel === SupeAdminAccessLevel;
      },
      canAddUser(){
        // For Australian environment with StaffApi enabled, hide the Add User button
        if (isAustraliaResHub() && this.facility?.isEnabledStaffAPI) {
          return false;
        }
        if (!this.facility?.featureMaintenance && this.facility?.isEnabledStaffAPI) {
          return false;
        }
        return hasAccess(this.currentUser.accessLevel, AccessMatrixKeys.Settings_UserManagementList_AddUser)
      },
      pdfPages() {
        return PdfPages;
      },
      canSendUserInvites() {
        return hasAccess(this.currentUser.accessLevel, AccessMatrixKeys.Settings_UserManagementList_SendUserInvites)
      },
    },
    data() {
      return {
        search: "",
        dialog: false,
        isFacilitiesLoading: false,
        accessLevelsEnum: StaffAccessLevels,
        headers: [
          {
            text: "",
            align: "",
            sortable: false,
            width: 70,
            value: "profilePicUrl"
          },
          {
            text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Name'],
            align: "start",
            sortable: false,
            value: "name"
          },
          {
            text: this.$i18n.messages[this.$i18n.locale]['Settings.StaffUsersList.AccessLevel'],
            align: "start",
            sortable: false,
            value: "accessLevelDisplay"
          },
          {
            text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Email'],
            align: "start",
            sortable: false,
            value: "email"
          },
          {
            text: this.$i18n.messages[this.$i18n.locale]['Settings.StaffUsersList.ImportedFromMCare'],
            align: "start",
            sortable: false,
            value: "originDisplay"
          },
          {
            text: this.$i18n.messages[this.$i18n.locale]['Settings.StaffUsersList.AccountVerified'],
            align: "start",
            sortable: false,
            value: "verificationStatusDisplay"
          }
        ],
        form: {
          name: "",
          email: "",
          facilities: [],
          accessLevel: "",
          roles: [],
          rolesIds: [],
        },
        submited: false,
        selectedFacilitiesIds: [],
        facilitySearch: "",
        loading: true,
      };
    },
    async created() {
      const fromPath = this.$route.meta.fromPath || "";
      if (fromPath.includes('/settings/users/')) return;

      await this.loadInitialData()
    },
    mounted() {
      this.search = this.staffUsersListFilters.search
      this.selectedFacilitiesIds = this.staffUsersListFilters.selectedFacilitiesIds
    },
    destroyed(){
      if(!this.$route.path.includes('/settings/users/')){
        this.clearStoredFilters()
      }
    },
    methods: {
      async loadInitialData(){
        // Org Admins see all org users, other roles see only their facility's users
        if (this.isOrgAdmin) {
          this.$store.dispatch("getOrgUsers", this.user.orgId);
        } else {
          this.$store.dispatch("getCurrentFacilityUsers");
        }
        
        this.$store.dispatch("getFacilityEmailTemplates");
        this.$store.dispatch("getMaintenanceCategories");
        
        // Load facilities for org admins and home admins who need to create users
        if (this.isOrgAdmin || this.isHomeAdmin) {
          this.isFacilitiesLoading = true
          await this.$store.dispatch("getFacilitiesForOrg");
          this.isFacilitiesLoading = false;
        }
        
        this.loading = false;
      },
      handleClickUser(row) {
        this.$router.push("/settings/users/" + row.id);
      },
      getVerificationStatusColor(status) {
        switch (status) {
          case 'Verified':
            return 'success';
          case 'Pending':
            return 'warning';
          case 'Not Invited':
            return 'grey';
          default:
            return 'grey';
        }
      },
      getVerificationStatusIcon(status) {
        switch (status) {
          case 'Verified':
            return 'mdi-check-circle';
          case 'Pending':
            return 'mdi-clock-outline';
          case 'Not Invited':
            return 'mdi-email-outline';
          default:
            return 'mdi-help-circle-outline';
        }
      },
      async submit() {

        if (this.submited == true) return true

        this.submited = true;

        const isValidEmail = await this.validateEmail(this.form.email);

        if (!isValidEmail) {
          this.$refs.observer.setErrors({
            Email: [this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.EmailAlreadyExists']]
          });

          this.submited = false;

          return;
        }

        const facilities = this.form.facilities.map(facility => ({
          id: facility.id,
          name: facility.name
        }));

        const facilitiesIds = this.form.facilities.map(facility => facility.id);
        const facility = this.form.facilities[0];

        const user = {
          ...this.form,
          facilityId: facility.id,
          regionId: facility.regionId,
          orgId: facility.orgId,
          facilities,
          facilitiesIds,
          profilePicUrl: DEFAULT_AVATAR_BLACK,
          createdById: this.currentUser.id,
          createdByType: UserTypeEnum.Staff,
          typesOfRecordChanged: [`${Tier1.StaffHubSettings}: ${Tier2.StaffSettings}: ${Tier3.UserManagement}`],
        };

        if(this.form.roles?.length) {
          const rolesIds = this.form.roles.map(roleName => {
            const role = this.usersRoles.find(x => x.name === roleName);
            if(role) {
              return role.id;
            }
          });

          user.rolesIds = rolesIds;
        } else {
          delete user.roles;
        }

         await this.$store.dispatch("createNewFacilityUser", {
           user,
           orgId: facility.orgId
         }).finally(() => {
           this.submited = false;
           this.resetForm()
         });

        this.dialog = false;
      },
      resetForm(){
        this.form.name = ""
        this.form.email = ""
        this.form.facilities = []
        this.form.accessLevel = ""
        this.form.roles = ""
        this.$refs.createUserForm.reset();
        this.$refs.observer.reset();
      },
      cancel() {
        this.dialog = false;
        this.resetForm()
      },
      async validateEmail(email) {

        const result = await firebase.app().functions(getRegionName())
          .httpsCallable("checkIfEmailExists")({
          emailAddress: email,
          orgId: this.facility.orgId
        });

        if (result.data.data.number > 0) {
          return false;
        }

        return true;
      },
      openManageRolesDialog() {
        this.$refs.facilityUsersRolesDialog.open();
      },
      openUserAddRoleDialog() {
        this.$refs.facilityUserAddRoleDialog.open();
      },
      openUserInvitesDialog() {
        this.$refs.inviteUsersDialogRef.open(this.facility.id, this.facility.orgId);
      },
      onFilterChanged(){
        const filters = {
            search: this.search || '',
            selectedFacilitiesIds: this.selectedFacilitiesIds || []
        }
        this.$store.dispatch("storeStaffUsersListFilters", filters);
      },
      clearStoredFilters(){
        this.$store.dispatch("storeStaffUsersListFilters", {
            search: '',
            selectedFacilitiesIds: []
        });
      }
    },
    watch: {
      selectedFacilitiesIds() {
        this.facilitySearch = "";
      }
    }
  };
</script>

<style lang="scss">
  .v-application #user-management {
    .v-card {
      box-shadow: none !important;
    }
  }

  .fixed-width {
    max-width: 310px;
  }
</style>
